// extracted by mini-css-extract-plugin
module.exports = {"container":"NxPage__container--26ginx6wCgbo3Tn0H-W8Tu"};